import { useNexaStore } from '../NexaStore';

/**
 * Hook to check if the current session has events
 * @returns Object with hasEvents boolean and isShareId boolean
 */
export const useHasEvents = () => {
  const { events, id } = useNexaStore((state) => ({
    events: state.events,
    id: state.id,
  }));

  // Check if ID is a share ID (starts with sh_)
  const isShareId = id?.startsWith('sh_');

  // Check if there are events
  const hasEvents = id && events && events.length > 0;

  return {
    hasEvents: Boolean(hasEvents),
    isShareId: Boolean(isShareId),
    eventsCount: events?.length || 0,
  };
};
